import { IdentityEvent } from '../../services/common/events/identity'
import { SimpleEvents } from '../../utils/events'
import { Store } from '../../utils/storage/keys'

const VIEWED_ARTICLES_SIZE = 100
const TRIGGER_RECOMMENDATION_MODAL = [1, 5] // tslint:disable-line: no-magic-numbers
export interface IViewedArticle {
    id: string,
    expTs: number
}

/*
 * This service counts the number of visits of the user.
 * */
export class RecommendationsService extends SimpleEvents {
    public initialize(articleId?: string, isRecommendationEnabled?: boolean, isWelcomeToMyTopicsModalEnabled?: boolean,
                      categories?: string[]) {
        // listening for mParticle ready event, to get session uuid
        if (isRecommendationEnabled === true && isWelcomeToMyTopicsModalEnabled === true) {
            addEventListener(IdentityEvent.MP_READY, (e: any) => {
                if (e.detail.mpSessionUuid) {
                    this.countUserVisits(e.detail.mpSessionUuid, categories)
                }
            })
        } else {
            // delete cookie that counts user visits
            document.cookie = 'visitsCounter=; max-age=0; path=/'
        }

        if (isRecommendationEnabled === true && articleId) {
            // Create or update viewed articles list
            this.updateViewedArticles(articleId)
        }

    }

    /*
     * This function counts the number of visits of the user.
     * It uses a cookie to store the number of visits and the last session uuid.
     * The cookie is set with one year expiration.
     * */
    private countUserVisits(sessionUuid: string, categories?: string[]) {
        let firstVisitTime = Date.now()
        let lastSessionUUID = ''
        let visitsCount = 0
        try {
            // read visitsCounter cookie
            const visitsCounterCookie =
                (document.cookie.split(';').find((c) => c.trim().startsWith('visitsCounter=')) || '')
                    .trim()
                    .split('=')
                    .pop() || '{}'
            const visitsCounterContent = JSON.parse(visitsCounterCookie)
            firstVisitTime = Number(visitsCounterContent.fistVisitTime) || Date.now()
            visitsCount = Number(visitsCounterContent.visitsCount) || 0
            lastSessionUUID = visitsCounterContent.lastSessionUUID || ''
        } catch {
            // treat cookie as empty if it is not valid
        }
        if (lastSessionUUID !== sessionUuid) {
            // if lastSessionUUID is different from current session uuid, increment visitsCount
            // and update lastSessionUUID
            const visitsCounter = {
                firstVisitTime,
                lastSessionUUID: sessionUuid,
                visitsCount: visitsCount + 1,
            }

            if (TRIGGER_RECOMMENDATION_MODAL.includes(visitsCounter.visitsCount) && categories === undefined) {
                document.dispatchEvent(
                    new CustomEvent(IdentityEvent.OPEN_RECOMMENDATION_MODAL)
                )
            }
            // set cookie with one year expiration
            const oneYearInSeconds = 365 * 24 * 60 * 60 // tslint:disable-line: no-magic-numbers
            document.cookie = `visitsCounter=${JSON.stringify(visitsCounter)}; max-age=${oneYearInSeconds}; path=/`
        }
    }

    /**
     * Update The list of articles the user Viewed.
     * It uses local storage to store the articles Id and there expiration dates (when the Id
     * should be remove from the list)
     */
    private updateViewedArticles(articleId: string) {
        const viewedArticles: IViewedArticle [] = JSON.parse(window.localStorage.getItem(
            Store.VIEWED_ARTICLES)) || []
        let isArticleExist = false
        const currentDate: Date =  new Date()

        const validViewedArticles: IViewedArticle []=[]
        for (const viewedArticle of viewedArticles ) {

            const expiryDate = new Date(viewedArticle.expTs)
            if(expiryDate > currentDate) {
                // article is not expired and should be kept in the list
                validViewedArticles.push(viewedArticle)
                if (viewedArticle.id === articleId) {
                    isArticleExist = true
                }
            }
        }
        if(!isArticleExist) {
            const expiryDate: Date = currentDate
            expiryDate.setMonth(expiryDate.getMonth() + 1)
            const currentArticle: IViewedArticle= {
                expTs: expiryDate.valueOf(),
                id: articleId
            }
            // if List reach max size remove oldest article
            if(validViewedArticles.length >= VIEWED_ARTICLES_SIZE) {
                validViewedArticles.shift()
            }
            validViewedArticles.push(currentArticle)
        }
        // update localStorage
        window.localStorage.setItem(Store.VIEWED_ARTICLES,JSON.stringify(validViewedArticles))
    }
}
